module.exports = __webpack_public_path__ + "img/732f064decc4c89e356ca25662f8e0b8.png";